// extracted by mini-css-extract-plugin
module.exports = {"sponsoredBanner":"Xo-z","sponsoredTooltipWrapper":"Yo-z","sponsoredTooltip":"Zo-z","newCard":"_o-z"};